import { GlobalController } from 'src/shared/global/GlobalController'
import ServiceRequestClientCard from './ServiceRequestClientCard'
import ClientUnitHistory from './ClientUnitHistory'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'registration-information/client-card',
    name:
      'serviceRequest.registration-information.client-card',
    component: ServiceRequestClientCard,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  },
  {
    path: 'registration-information/client-card-history',
    name:
      'serviceRequest.registration-information.client-card-history',
    component: ClientUnitHistory,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
